import React from "react";
import css from "./Homepage.module.css";


const Tutorial = () => {
    return (
        <div className={css.tutorialPage}>
            <iframe className={css.tutorialFrame} src="tutorialitgraph.html"></iframe>
        </div>
    )
}

export default Tutorial;
